/**
 * Generated by orval v6.10.3 🍺
 * Do not edit manually.
 * Your Project
 * API for all things …
 * OpenAPI spec version: 1.0.0
 */
import axios from 'axios'
import type {
  AxiosRequestConfig,
  AxiosResponse,
  AxiosError
} from 'axios'
import {
  useQuery,
  useMutation
} from '@tanstack/react-query'
import type {
  UseQueryOptions,
  UseMutationOptions,
  QueryFunction,
  MutationFunction,
  UseQueryResult,
  QueryKey
} from '@tanstack/react-query'
import type {
  Designation
} from '../../schema'


/**
 * Get designation details
 */
export const retrieveDesignation = (
    id: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Designation>> => {
    return axios.get(
      `/designation/${id}`,options
    );
  }


export const getRetrieveDesignationQueryKey = (id: string,) => [`/designation/${id}`];

    
export type RetrieveDesignationQueryResult = NonNullable<Awaited<ReturnType<typeof retrieveDesignation>>>
export type RetrieveDesignationQueryError = AxiosError<unknown>

export const useRetrieveDesignation = <TData = Awaited<ReturnType<typeof retrieveDesignation>>, TError = AxiosError<unknown>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof retrieveDesignation>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getRetrieveDesignationQueryKey(id);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof retrieveDesignation>>> = ({ signal }) => retrieveDesignation(id, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof retrieveDesignation>>, TError, TData>(queryKey, queryFn, {enabled: !!(id), ...queryOptions}) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * Update designation details
 */
export const updateDesignation = (
    id: string,
    designation: Designation, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Designation>> => {
    return axios.put(
      `/designation/${id}`,
      designation,options
    );
  }



    export type UpdateDesignationMutationResult = NonNullable<Awaited<ReturnType<typeof updateDesignation>>>
    export type UpdateDesignationMutationBody = Designation
    export type UpdateDesignationMutationError = AxiosError<unknown>

    export const useUpdateDesignation = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateDesignation>>, TError,{id: string;data: Designation}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateDesignation>>, {id: string;data: Designation}> = (props) => {
          const {id,data} = props ?? {};

          return  updateDesignation(id,data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof updateDesignation>>, TError, {id: string;data: Designation}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * Delete a designation
 */
export const destroyDesignation = (
    id: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.delete(
      `/designation/${id}`,options
    );
  }



    export type DestroyDesignationMutationResult = NonNullable<Awaited<ReturnType<typeof destroyDesignation>>>
    
    export type DestroyDesignationMutationError = AxiosError<unknown>

    export const useDestroyDesignation = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyDesignation>>, TError,{id: string}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof destroyDesignation>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  destroyDesignation(id,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof destroyDesignation>>, TError, {id: string}, TContext>(mutationFn, mutationOptions)
    }
    